<div class="w-full md:w-2/3 mx-auto px-4">
  <div class="text-center mb-8">
    <h1 class="text-2xl font-bold mb-4">Schön, dass du hier bist!</h1>
    <p class="text-gray-600">
      Um dir passende Ergebnisse liefern zu können, benötigen wir noch ein paar
      Informationen zu deiner Person.
    </p>
  </div>

  <form [formGroup]="userForm" (ngSubmit)="onSubmit()" class="user-form">
    <div class="flex flex-row gap-4">
      <div class="w-full">
        <mat-form-field class="w-full">
          <mat-label>Vorname</mat-label>
          <input
            matInput
            formControlName="firstName"
            placeholder="Vorname eingeben"
            />
          @if (userForm.get('firstName')?.errors?.['required']) {
            <mat-error>
              Vorname ist erforderlich
            </mat-error>
          }
        </mat-form-field>
      </div>

      <div class="w-full">
        <mat-form-field class="w-full">
          <mat-label>Nachname</mat-label>
          <input
            matInput
            formControlName="lastName"
            placeholder="Nachname eingeben"
            />
          @if (userForm.get('lastName')?.errors?.['required']) {
            <mat-error>
              Nachname ist erforderlich
            </mat-error>
          }
        </mat-form-field>
      </div>
    </div>

    <div class="flex flex-row gap-4">
      <div class="w-full">
        <mat-form-field class="w-full">
          <mat-label>Geschlecht</mat-label>
          <mat-select formControlName="gender">
            <mat-option value="male">Männlich</mat-option>
            <mat-option value="female">Weiblich</mat-option>
            <mat-option value="diverse">Divers</mat-option>
            <mat-option value="other">Keine Angabe</mat-option>
          </mat-select>
          @if (userForm.get('gender')?.errors?.['required']) {
            <mat-error>
              Geschlecht ist erforderlich
            </mat-error>
          }
        </mat-form-field>
      </div>

      <div class="w-full">
        <mat-form-field class="w-full">
          <mat-label>Geburtsjahr</mat-label>
          <input
            matInput
            formControlName="birthYear"
            type="number"
            placeholder="Geburtsjahr eingeben"
            />
          @if (userForm.get('birthYear')?.errors?.['min'] || userForm.get('birthYear')?.errors?.['max']) {
            <mat-error
              >
              Bitte geben Sie ein gültiges Geburtsjahr ein
            </mat-error>
          }
        </mat-form-field>
      </div>
    </div>

    <div class="form-group">
      <mat-form-field class="w-1/2">
        <mat-label>PLZ</mat-label>
        <input matInput formControlName="zipCode" placeholder="PLZ eingeben" />
        @if (userForm.get('zipCode')?.errors?.['pattern']) {
          <mat-error>
            Bitte geben Sie eine gültige PLZ ein
          </mat-error>
        }
      </mat-form-field>
    </div>

    <!-- <div class="form-group">
    <div class="profile-picture-upload">
      <input type="file" #fileInput accept="image/*" style="display: none" (change)="onFileSelected($event)">
      <button type="button" mat-raised-button color="primary" (click)="fileInput.click()">
        <mat-icon>cloud_upload</mat-icon>
        Profilbild hochladen
      </button>
      <span *ngIf="userForm.get('profilePicture')?.value" class="file-name">
        {{ userForm.get('profilePicture')?.value }}
      </span>
    </div>
  </div> -->

  <div class="form-group">
    <mat-checkbox formControlName="acceptedPrivacyPolicy" color="primary">
      <span i18n
        >Ich stimme der
          <a
            href="https://www.sondis.at/datenschutzerklaerung/"
            target="_blank"
            rel="noopener noreferrer"
            >Datenschutzerklärung
            <mat-icon class="text-sm">open_in_new</mat-icon></a
          >
          zu</span
          >
        </mat-checkbox>
        @if (userForm.get('acceptedPrivacyPolicy')?.errors?.['required'] && userForm.get('acceptedPrivacyPolicy')?.touched) {
          <mat-error
            >
            Sie müssen die Datenschutzerklärung akzeptieren
          </mat-error>
        }
      </div>

      <div class="form-group">
        <mat-checkbox formControlName="acceptedAgb" color="primary">
          <span i18n
            >Ich akzeptiere die
          <a
            href="https://www.sondis.at/agb/"
            target="_blank"
            rel="noopener noreferrer"
            >AGB <mat-icon class="text-sm">open_in_new</mat-icon></a
          ></span
              >
            </mat-checkbox>
            @if (userForm.get('acceptedAgb')?.errors?.['required'] && userForm.get('acceptedAgb')?.touched) {
              <mat-error
                >
                Sie müssen die AGB akzeptieren
              </mat-error>
            }
          </div>

          <div class="form-actions mt-4">
            <button
              i18n
              class="button-blue"
              type="submit"
              [disabled]="!userForm.valid || loading"
              >
        Registrierung abschließen
      </button>
          </div>
        </form>
      </div>
